import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTheme = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.25 22v-5a.917.917 0 0 0-.917-.916h-1.666a.917.917 0 0 0-.917.917v5a.75.75 0 0 1-1.5 0v-5a2.42 2.42 0 0 1 2.417-2.417h1.666A2.417 2.417 0 0 1 17.75 17v5a.75.75 0 0 1-1.5 0",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.75 15.334a2.583 2.583 0 0 0-2.583-2.583H5.333A4.084 4.084 0 0 1 1.25 8.667V7.001a2.417 2.417 0 0 1 2.417-2.417h1.666a.75.75 0 1 1 0 1.5H3.667a.917.917 0 0 0-.917.917v1.666a2.584 2.584 0 0 0 2.583 2.584h5.834a4.083 4.083 0 0 1 4.083 4.083.75.75 0 1 1-1.5 0",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.25 3.667a.917.917 0 0 0-.917-.917H7a.917.917 0 0 0-.917.917V7c0 .507.411.917.917.917h13.333c.507 0 .917-.41.917-.917zM22.75 7a2.417 2.417 0 0 1-2.417 2.417H7A2.417 2.417 0 0 1 4.583 7V3.667A2.417 2.417 0 0 1 7 1.25h13.333a2.417 2.417 0 0 1 2.417 2.417z",
			fill: "currentColor"
		})
	]
});
export default SvgTheme;
